/**
 * External dependencies
 */

/**
 * WordPress dependencies
 */
import { __experimentalHStack as HStack } from '@wordpress/components';
import { useMemo, useState } from '@wordpress/element';

/**
 * Internal dependencies
 */
import Pagination from './pagination';
import ViewActions from './view-actions';
import Filters from './filters';
import Search from './search';
import { LAYOUT_TABLE, LAYOUT_GRID } from './constants';
import { VIEW_LAYOUTS } from './layouts';
import { default as BulkActions, useSomeItemHasAPossibleBulkAction } from './bulk-actions';
import { normalizeFields } from './normalize-fields';
import BulkActionsToolbar from './bulk-actions-toolbar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultGetItemId = item => item.id;
const defaultOnSelectionChange = () => {};
export default function DataViews({
  view,
  onChangeView,
  fields,
  search = true,
  searchLabel = undefined,
  actions = [],
  data,
  getItemId = defaultGetItemId,
  isLoading = false,
  paginationInfo,
  defaultLayouts,
  selection: selectionProperty,
  setSelection: setSelectionProperty,
  onSelectionChange = defaultOnSelectionChange
}) {
  const [selectionState, setSelectionState] = useState([]);
  const isUncontrolled = selectionProperty === undefined || setSelectionProperty === undefined;
  const selection = isUncontrolled ? selectionState : selectionProperty;
  const setSelection = isUncontrolled ? setSelectionState : setSelectionProperty;
  const [openedFilter, setOpenedFilter] = useState(null);
  function setSelectionWithChange(value) {
    const newValue = typeof value === 'function' ? value(selection) : value;
    onSelectionChange(data.filter(item => newValue.includes(getItemId(item))));
    return setSelection(value);
  }
  const ViewComponent = VIEW_LAYOUTS.find(v => v.type === view.type)?.component;
  const _fields = useMemo(() => normalizeFields(fields), [fields]);
  const hasPossibleBulkAction = useSomeItemHasAPossibleBulkAction(actions, data);
  const _selection = useMemo(() => {
    return selection.filter(id => data.some(item => getItemId(item) === id));
  }, [selection, data, getItemId]);
  return /*#__PURE__*/_jsxs("div", {
    className: "dataviews-wrapper",
    children: [/*#__PURE__*/_jsxs(HStack, {
      alignment: "top",
      justify: "start",
      className: "dataviews-filters__view-actions",
      children: [/*#__PURE__*/_jsxs(HStack, {
        justify: "start",
        className: "dataviews-filters__container",
        wrap: true,
        children: [search && /*#__PURE__*/_jsx(Search, {
          label: searchLabel,
          view: view,
          onChangeView: onChangeView
        }), /*#__PURE__*/_jsx(Filters, {
          fields: _fields,
          view: view,
          onChangeView: onChangeView,
          openedFilter: openedFilter,
          setOpenedFilter: setOpenedFilter
        })]
      }), [LAYOUT_TABLE, LAYOUT_GRID].includes(view.type) && hasPossibleBulkAction && /*#__PURE__*/_jsx(BulkActions, {
        actions: actions,
        data: data,
        onSelectionChange: setSelectionWithChange,
        selection: _selection,
        getItemId: getItemId
      }), /*#__PURE__*/_jsx(ViewActions, {
        fields: _fields,
        view: view,
        onChangeView: onChangeView,
        defaultLayouts: defaultLayouts
      })]
    }), /*#__PURE__*/_jsx(ViewComponent, {
      actions: actions,
      data: data,
      fields: _fields,
      getItemId: getItemId,
      isLoading: isLoading,
      onChangeView: onChangeView,
      onSelectionChange: setSelectionWithChange,
      selection: _selection,
      setOpenedFilter: setOpenedFilter,
      view: view
    }), /*#__PURE__*/_jsx(Pagination, {
      view: view,
      onChangeView: onChangeView,
      paginationInfo: paginationInfo
    }), [LAYOUT_TABLE, LAYOUT_GRID].includes(view.type) && hasPossibleBulkAction && /*#__PURE__*/_jsx(BulkActionsToolbar, {
      data: data,
      actions: actions,
      selection: _selection,
      onSelectionChange: setSelectionWithChange,
      getItemId: getItemId
    })]
  });
}
//# sourceMappingURL=dataviews.js.map